import { render, staticRenderFns } from "./ResetBox.vue?vue&type=template&id=034173a4&scoped=true&"
import script from "./ResetBox.vue?vue&type=script&lang=js&"
export * from "./ResetBox.vue?vue&type=script&lang=js&"
import style0 from "./ResetBox.vue?vue&type=style&index=0&id=034173a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034173a4",
  null
  
)

export default component.exports